import { QcTestExecutionSubmission } from '../../types'
import apiClient from '../apiClient'
import { ENDPOINTS } from '../endpoints'

export const qualityTestService = {
  get: async (siteId: string, id: string) => {
    const response = await apiClient.get(ENDPOINTS.qualityTests.get(siteId, id))
    return response.data
  },

  getHistory: async (
    siteId: string,
    qualityTestId: string,
    params?: {
      startDate?: string
      endDate?: string
      pageNumber?: number
      pageSize?: number
    },
  ) => {
    const response = await apiClient.get(ENDPOINTS.qualityTestExecutions.getTestHistory(siteId, qualityTestId), {
      params,
    })
    return response.data
  },

  submit: async (siteId: string, versionId: string, body: QcTestExecutionSubmission) => {
    const response = await apiClient.post(ENDPOINTS.qualityTestExecutions.submit(siteId, versionId), body)
    return response.data
  },
}
